/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

import { UserContactType } from './common-proxies';
import { API_BASE_URL, blobToText, throwException } from './proxy-helpers';
import { UserListDto, UserLoginInfoDto } from './shared-models';

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<FlatPermissionWithLevelDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Permission/GetAllPermissions';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllPermissions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllPermissions(<any>response_);
                        } catch (e) {
                            return <Observable<FlatPermissionWithLevelDtoListResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FlatPermissionWithLevelDtoListResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<FlatPermissionWithLevelDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FlatPermissionWithLevelDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FlatPermissionWithLevelDtoListResultDto>(<any>null);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Profile/GetCurrentUserProfileForEdit';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCurrentUserProfileForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCurrentUserProfileForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<CurrentUserProfileEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<CurrentUserProfileEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = CurrentUserProfileEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<CurrentUserProfileEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Profile/UpdateCurrentUserProfile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateCurrentUserProfile(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateCurrentUserProfile(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param profilePictureId (optional)
     * @param userId (optional)
     * @param tenantId (optional)
     * @return Success
     */
    getFriendProfilePictureById(
        profilePictureId: string | undefined,
        userId: number | undefined,
        tenantId: number | undefined
    ): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + '/api/services/app/Profile/GetFriendProfilePictureById?';
        if (profilePictureId === null) throw new Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined) url_ += 'ProfilePictureId=' + encodeURIComponent('' + profilePictureId) + '&';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
        if (tenantId === null) throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined) url_ += 'TenantId=' + encodeURIComponent('' + tenantId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetFriendProfilePictureById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetFriendProfilePictureById(<any>response_);
                        } catch (e) {
                            return <Observable<GetProfilePictureOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetProfilePictureOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetFriendProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetProfilePictureOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param profilePictureId (optional)
     * @return Success
     */
    getProfilePictureById(profilePictureId: string | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + '/api/services/app/Profile/GetProfilePictureById?';
        if (profilePictureId === null) throw new Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined) url_ += 'profilePictureId=' + encodeURIComponent('' + profilePictureId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetProfilePictureById(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetProfilePictureById(<any>response_);
                        } catch (e) {
                            return <Observable<GetProfilePictureOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetProfilePictureOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetProfilePictureOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }

    /**
     * @param contactId (optional)
     * @return Success
     */
    getContactProfilePicture(contactId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + '/api/services/app/Profile/GetContactProfilePicture?';
        if (contactId === null) throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined) url_ += 'contactId=' + encodeURIComponent('' + contactId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetContactProfilePicture(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetContactProfilePicture(<any>response_);
                        } catch (e) {
                            return <Observable<GetProfilePictureOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetProfilePictureOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetContactProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetProfilePictureOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetProfilePictureOutput>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/Create';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreate(<any>response_);
                        } catch (e) {
                            return <Observable<RoleDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<RoleDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RoleDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdate(<any>response_);
                        } catch (e) {
                            return <Observable<RoleDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<RoleDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RoleDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Role/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDelete(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDelete(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/GetAllPermissions';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAllPermissions(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAllPermissions(<any>response_);
                        } catch (e) {
                            return <Observable<PermissionDtoListResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<PermissionDtoListResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = PermissionDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<PermissionDtoListResultDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/Get?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGet(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGet(<any>response_);
                        } catch (e) {
                            return <Observable<RoleDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<RoleDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RoleDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param keyword (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAll(
        keyword: string | undefined,
        skipCount: number | undefined,
        maxResultCount: number | undefined
    ): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/GetAll?';
        if (keyword === null) throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined) url_ += 'Keyword=' + encodeURIComponent('' + keyword) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAll(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAll(<any>response_);
                        } catch (e) {
                            return <Observable<RoleDtoPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<RoleDtoPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RoleDtoPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RoleDtoPagedResultDto>(<any>null);
    }

    /**
     * @param permission (optional)
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/GetRoles?';
        if (permission === null) throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined) url_ += 'Permission=' + encodeURIComponent('' + permission) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetRoles(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetRoles(<any>response_);
                        } catch (e) {
                            return <Observable<RoleListDtoListResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<RoleListDtoListResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = RoleListDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<RoleListDtoListResultDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Role/GetRoleForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetRoleForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetRoleForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<GetRoleForEditOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetRoleForEditOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetRoleForEditOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Role/CreateOrUpdateRole';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateRole(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateRole(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteRole(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Role/DeleteRole?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteRole(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteRole(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getMarketplaceRoles(): Observable<MarketplaceRoleDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Role/GetMarketplaceRoles';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetMarketplaceRoles(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetMarketplaceRoles(<any>response_);
                        } catch (e) {
                            return <Observable<MarketplaceRoleDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<MarketplaceRoleDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetMarketplaceRoles(response: HttpResponseBase): Observable<MarketplaceRoleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(MarketplaceRoleDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<MarketplaceRoleDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateMarketplaceRoleMapping(body: MarketplaceRoleMappingDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Role/UpdateMarketplaceRoleMapping';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateMarketplaceRoleMapping(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateMarketplaceRoleMapping(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateMarketplaceRoleMapping(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + '/api/services/app/Session/GetCurrentLoginInformations';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCurrentLoginInformations(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCurrentLoginInformations(<any>response_);
                        } catch (e) {
                            return <Observable<GetCurrentLoginInformationsOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<GetCurrentLoginInformationsOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<UserLoginAttemptDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/UserLogin/GetRecentUserLoginAttempts';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetRecentUserLoginAttempts(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetRecentUserLoginAttempts(<any>response_);
                        } catch (e) {
                            return <Observable<UserLoginAttemptDtoListResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserLoginAttemptDtoListResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetRecentUserLoginAttempts(response: HttpResponseBase): Observable<UserLoginAttemptDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = UserLoginAttemptDtoListResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserLoginAttemptDtoListResultDto>(<any>null);
    }
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    branch: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean } | undefined;
    currentCulture: string | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data['version'];
            this.branch = _data['branch'];
            this.releaseDate = _data['releaseDate'] ? moment(_data['releaseDate'].toString()) : <any>undefined;
            if (_data['features']) {
                this.features = {} as any;
                for (let key in _data['features']) {
                    if (_data['features'].hasOwnProperty(key)) this.features[key] = _data['features'][key];
                }
            }
            this.currentCulture = _data['currentCulture'];
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['version'] = this.version;
        data['branch'] = this.branch;
        data['releaseDate'] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data['features'] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key)) data['features'][key] = this.features[key];
            }
        }
        data['currentCulture'] = this.currentCulture;
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    branch: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean } | undefined;
    currentCulture: string | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data['languageName'];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['languageName'] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
    description: string | undefined;

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data['role'] ? RoleEditDto.fromJS(_data['role']) : new RoleEditDto();
            if (Array.isArray(_data['grantedPermissionNames'])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames.push(item);
            }
            this.description = _data['description'];
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['role'] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data['grantedPermissionNames'] = [];
            for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
        }
        data['description'] = this.description;
        return data;
    }

    clone(): CreateOrUpdateRoleInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateRoleInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
    description: string | undefined;
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user: UserEditDto;
    userContacts: UserContactDto[] | undefined;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    normalizedEmailAddress: string | undefined;
    normalizedUserName: string | undefined;
    uuid: string | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data['user'] ? UserEditDto.fromJS(_data['user']) : new UserEditDto();
            if (Array.isArray(_data['userContacts'])) {
                this.userContacts = [] as any;
                for (let item of _data['userContacts']) this.userContacts.push(UserContactDto.fromJS(item));
            }
            if (Array.isArray(_data['assignedRoleNames'])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data['assignedRoleNames']) this.assignedRoleNames.push(item);
            }
            this.sendActivationEmail = _data['sendActivationEmail'];
            this.setRandomPassword = _data['setRandomPassword'];
            this.normalizedEmailAddress = _data['normalizedEmailAddress'];
            this.normalizedUserName = _data['normalizedUserName'];
            this.uuid = _data['uuid'];
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.userContacts)) {
            data['userContacts'] = [];
            for (let item of this.userContacts) data['userContacts'].push(item.toJSON());
        }
        if (Array.isArray(this.assignedRoleNames)) {
            data['assignedRoleNames'] = [];
            for (let item of this.assignedRoleNames) data['assignedRoleNames'].push(item);
        }
        data['sendActivationEmail'] = this.sendActivationEmail;
        data['setRandomPassword'] = this.setRandomPassword;
        data['normalizedEmailAddress'] = this.normalizedEmailAddress;
        data['normalizedUserName'] = this.normalizedUserName;
        data['uuid'] = this.uuid;
        return data;
    }

    clone(): CreateOrUpdateUserInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateUserInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    userContacts: UserContactDto[] | undefined;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    normalizedEmailAddress: string | undefined;
    normalizedUserName: string | undefined;
    uuid: string | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    isInternalDefault: boolean;
    isAdvisorDefault: boolean;
    grantedPermissions: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.normalizedName = _data['normalizedName'];
            this.description = _data['description'];
            this.isInternalDefault = _data['isInternalDefault'];
            this.isAdvisorDefault = _data['isAdvisorDefault'];
            if (Array.isArray(_data['grantedPermissions'])) {
                this.grantedPermissions = [] as any;
                for (let item of _data['grantedPermissions']) this.grantedPermissions.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['normalizedName'] = this.normalizedName;
        data['description'] = this.description;
        data['isInternalDefault'] = this.isInternalDefault;
        data['isAdvisorDefault'] = this.isAdvisorDefault;
        if (Array.isArray(this.grantedPermissions)) {
            data['grantedPermissions'] = [];
            for (let item of this.grantedPermissions) data['grantedPermissions'].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    isInternalDefault: boolean;
    isAdvisorDefault: boolean;
    grantedPermissions: string[] | undefined;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    title: string | undefined;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    timezone: string | undefined;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.title = _data['title'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.phoneNumber = _data['phoneNumber'];
            this.timezone = _data['timezone'];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['title'] = this.title;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['phoneNumber'] = this.phoneNumber;
        data['timezone'] = this.timezone;
        return data;
    }

    clone(): CurrentUserProfileEditDto {
        const json = this.toJSON();
        let result = new CurrentUserProfileEditDto();
        result.init(json);
        return result;
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    title: string | undefined;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    timezone: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data['parentName'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
            this.isGrantedByDefault = _data['isGrantedByDefault'];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['parentName'] = this.parentName;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        data['isGrantedByDefault'] = this.isGrantedByDefault;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data['level'];
            this.parentName = _data['parentName'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
            this.isGrantedByDefault = _data['isGrantedByDefault'];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['level'] = this.level;
        data['parentName'] = this.parentName;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        data['isGrantedByDefault'] = this.isGrantedByDefault;
        return data;
    }

    clone(): FlatPermissionWithLevelDto {
        const json = this.toJSON();
        let result = new FlatPermissionWithLevelDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FlatPermissionWithLevelDtoListResultDto implements IFlatPermissionWithLevelDtoListResultDto {
    items: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IFlatPermissionWithLevelDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): FlatPermissionWithLevelDtoListResultDto {
        const json = this.toJSON();
        let result = new FlatPermissionWithLevelDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionWithLevelDtoListResultDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data['application'] ? ApplicationInfoDto.fromJS(_data['application']) : <any>undefined;
            this.user = _data['user'] ? UserLoginInfoDto.fromJS(_data['user']) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['application'] = this.application ? this.application.toJSON() : <any>undefined;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data['profilePicture'];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['profilePicture'] = this.profilePicture;
        return data;
    }

    clone(): GetProfilePictureOutput {
        const json = this.toJSON();
        let result = new GetProfilePictureOutput();
        result.init(json);
        return result;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data['role'] ? RoleEditDto.fromJS(_data['role']) : <any>undefined;
            if (Array.isArray(_data['permissions'])) {
                this.permissions = [] as any;
                for (let item of _data['permissions']) this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data['grantedPermissionNames'])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['role'] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data['permissions'] = [];
            for (let item of this.permissions) data['permissions'].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data['grantedPermissionNames'] = [];
            for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    userContacts: UserContactDto[] | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data['profilePictureId'];
            this.user = _data['user'] ? UserEditDto.fromJS(_data['user']) : <any>undefined;
            if (Array.isArray(_data['roles'])) {
                this.roles = [] as any;
                for (let item of _data['roles']) this.roles.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data['userContacts'])) {
                this.userContacts = [] as any;
                for (let item of _data['userContacts']) this.userContacts.push(UserContactDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['profilePictureId'] = this.profilePictureId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data['roles'] = [];
            for (let item of this.roles) data['roles'].push(item.toJSON());
        }
        if (Array.isArray(this.userContacts)) {
            data['userContacts'] = [];
            for (let item of this.userContacts) data['userContacts'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetUserForEditOutput {
        const json = this.toJSON();
        let result = new GetUserForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    userContacts: UserContactDto[] | undefined;
}

export class GetUserInfoOutput implements IGetUserInfoOutput {
    id: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    roleNames: string[] | undefined;
    partnerId: number | undefined;
    partnerName: string | undefined;
    providerId: number | undefined;
    providerName: string | undefined;

    constructor(data?: IGetUserInfoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.emailAddress = _data['emailAddress'];
            if (Array.isArray(_data['roleNames'])) {
                this.roleNames = [] as any;
                for (let item of _data['roleNames']) this.roleNames.push(item);
            }
            this.partnerId = _data['partnerId'];
            this.partnerName = _data['partnerName'];
            this.providerId = _data['providerId'];
            this.providerName = _data['providerName'];
        }
    }

    static fromJS(data: any): GetUserInfoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserInfoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['emailAddress'] = this.emailAddress;
        if (Array.isArray(this.roleNames)) {
            data['roleNames'] = [];
            for (let item of this.roleNames) data['roleNames'].push(item);
        }
        data['partnerId'] = this.partnerId;
        data['partnerName'] = this.partnerName;
        data['providerId'] = this.providerId;
        data['providerName'] = this.providerName;
        return data;
    }

    clone(): GetUserInfoOutput {
        const json = this.toJSON();
        let result = new GetUserInfoOutput();
        result.init(json);
        return result;
    }
}

export interface IGetUserInfoOutput {
    id: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    emailAddress: string | undefined;
    roleNames: string[] | undefined;
    partnerId: number | undefined;
    partnerName: string | undefined;
    providerId: number | undefined;
    providerName: string | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['permissions'])) {
                this.permissions = [] as any;
                for (let item of _data['permissions']) this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data['grantedPermissionNames'])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data['permissions'] = [];
            for (let item of this.permissions) data['permissions'].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data['grantedPermissionNames'] = [];
            for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
        }
        return data;
    }

    clone(): GetUserPermissionsForEditOutput {
        const json = this.toJSON();
        let result = new GetUserPermissionsForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class MarketplaceRoleDto implements IMarketplaceRoleDto {
    name: string | undefined;
    description: string | undefined;
    marketplaceRoleMappings: MarketplaceRoleMappingDto[] | undefined;
    id: number;

    constructor(data?: IMarketplaceRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.description = _data['description'];
            if (Array.isArray(_data['marketplaceRoleMappings'])) {
                this.marketplaceRoleMappings = [] as any;
                for (let item of _data['marketplaceRoleMappings'])
                    this.marketplaceRoleMappings.push(MarketplaceRoleMappingDto.fromJS(item));
            }
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): MarketplaceRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['description'] = this.description;
        if (Array.isArray(this.marketplaceRoleMappings)) {
            data['marketplaceRoleMappings'] = [];
            for (let item of this.marketplaceRoleMappings) data['marketplaceRoleMappings'].push(item.toJSON());
        }
        data['id'] = this.id;
        return data;
    }

    clone(): MarketplaceRoleDto {
        const json = this.toJSON();
        let result = new MarketplaceRoleDto();
        result.init(json);
        return result;
    }
}

export interface IMarketplaceRoleDto {
    name: string | undefined;
    description: string | undefined;
    marketplaceRoleMappings: MarketplaceRoleMappingDto[] | undefined;
    id: number;
}

export class MarketplaceRoleMappingDto implements IMarketplaceRoleMappingDto {
    marketplaceRoleId: number;
    roleId: number;

    constructor(data?: IMarketplaceRoleMappingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.marketplaceRoleId = _data['marketplaceRoleId'];
            this.roleId = _data['roleId'];
        }
    }

    static fromJS(data: any): MarketplaceRoleMappingDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarketplaceRoleMappingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['marketplaceRoleId'] = this.marketplaceRoleId;
        data['roleId'] = this.roleId;
        return data;
    }

    clone(): MarketplaceRoleMappingDto {
        const json = this.toJSON();
        let result = new MarketplaceRoleMappingDto();
        result.init(json);
        return result;
    }
}

export interface IMarketplaceRoleMappingDto {
    marketplaceRoleId: number;
    roleId: number;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        data['id'] = this.id;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class RoleDto implements IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.normalizedName = _data['normalizedName'];
            this.description = _data['description'];
            if (Array.isArray(_data['grantedPermissions'])) {
                this.grantedPermissions = [] as any;
                for (let item of _data['grantedPermissions']) this.grantedPermissions.push(item);
            }
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['normalizedName'] = this.normalizedName;
        data['description'] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data['grantedPermissions'] = [];
            for (let item of this.grantedPermissions) data['grantedPermissions'].push(item);
        }
        data['id'] = this.id;
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    totalCount: number;
    items: RoleDto[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
    isInternalDefault: boolean;
    isAdvisorDefault: boolean;
    description: string | undefined;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.displayName = _data['displayName'];
            this.isDefault = _data['isDefault'];
            this.isInternalDefault = _data['isInternalDefault'];
            this.isAdvisorDefault = _data['isAdvisorDefault'];
            this.description = _data['description'];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['displayName'] = this.displayName;
        data['isDefault'] = this.isDefault;
        data['isInternalDefault'] = this.isInternalDefault;
        data['isAdvisorDefault'] = this.isAdvisorDefault;
        data['description'] = this.description;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
    isInternalDefault: boolean;
    isAdvisorDefault: boolean;
    description: string | undefined;
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    isInternalDefault: boolean;
    isAdvisorDefault: boolean;
    creationTime: moment.Moment;
    id: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
            this.isStatic = _data['isStatic'];
            this.isDefault = _data['isDefault'];
            this.isInternalDefault = _data['isInternalDefault'];
            this.isAdvisorDefault = _data['isAdvisorDefault'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        data['isStatic'] = this.isStatic;
        data['isDefault'] = this.isDefault;
        data['isInternalDefault'] = this.isInternalDefault;
        data['isAdvisorDefault'] = this.isAdvisorDefault;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['id'] = this.id;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    isInternalDefault: boolean;
    isAdvisorDefault: boolean;
    creationTime: moment.Moment;
    id: number;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export enum RoleType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class RollDetails implements IRollDetails {
    rollType: RoleType;
    type: RoleType;
    name: string | undefined;

    constructor(data?: IRollDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rollType = _data['rollType'];
            this.type = _data['type'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): RollDetails {
        data = typeof data === 'object' ? data : {};
        let result = new RollDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['rollType'] = this.rollType;
        data['type'] = this.type;
        data['name'] = this.name;
        return data;
    }

    clone(): RollDetails {
        const json = this.toJSON();
        let result = new RollDetails();
        result.init(json);
        return result;
    }
}

export interface IRollDetails {
    rollType: RoleType;
    type: RoleType;
    name: string | undefined;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            if (Array.isArray(_data['grantedPermissionNames'])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data['grantedPermissionNames'] = [];
            for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
        }
        return data;
    }

    clone(): UpdateUserPermissionsInput {
        const json = this.toJSON();
        let result = new UpdateUserPermissionsInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class UserContactDto implements IUserContactDto {
    id: number;
    userId: number;
    type: UserContactType;
    number: string | undefined;

    constructor(data?: IUserContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.userId = _data['userId'];
            this.type = _data['type'];
            this.number = _data['number'];
        }
    }

    static fromJS(data: any): UserContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['userId'] = this.userId;
        data['type'] = this.type;
        data['number'] = this.number;
        return data;
    }

    clone(): UserContactDto {
        const json = this.toJSON();
        let result = new UserContactDto();
        result.init(json);
        return result;
    }
}

export interface IUserContactDto {
    id: number;
    userId: number;
    type: UserContactType;
    number: string | undefined;
}

export class UserDetailOutput implements IUserDetailOutput {
    role: string[] | undefined;
    userId: number | undefined;
    partnerId: number | undefined;
    providerId: number | undefined;

    constructor(data?: IUserDetailOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['role'])) {
                this.role = [] as any;
                for (let item of _data['role']) this.role.push(item);
            }
            this.userId = _data['userId'];
            this.partnerId = _data['partnerId'];
            this.providerId = _data['providerId'];
        }
    }

    static fromJS(data: any): UserDetailOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.role)) {
            data['role'] = [];
            for (let item of this.role) data['role'].push(item);
        }
        data['userId'] = this.userId;
        data['partnerId'] = this.partnerId;
        data['providerId'] = this.providerId;
        return data;
    }

    clone(): UserDetailOutput {
        const json = this.toJSON();
        let result = new UserDetailOutput();
        result.init(json);
        return result;
    }
}

export interface IUserDetailOutput {
    role: string[] | undefined;
    userId: number | undefined;
    partnerId: number | undefined;
    providerId: number | undefined;
}

export class UserDropdownDto implements IUserDropdownDto {
    id: number;
    name: string | undefined;
    emailAddress: string | undefined;

    constructor(data?: IUserDropdownDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.emailAddress = _data['emailAddress'];
        }
    }

    static fromJS(data: any): UserDropdownDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDropdownDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['emailAddress'] = this.emailAddress;
        return data;
    }

    clone(): UserDropdownDto {
        const json = this.toJSON();
        let result = new UserDropdownDto();
        result.init(json);
        return result;
    }
}

export interface IUserDropdownDto {
    id: number;
    name: string | undefined;
    emailAddress: string | undefined;
}

export class UserEditDto implements IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    title: string | undefined;
    officeAddress: string | undefined;
    officeAddress2: string | undefined;
    officeCity: string | undefined;
    officeState: string | undefined;
    officeZipcode: string | undefined;
    officeCountry: string | undefined;
    shippingAddress: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingState: string | undefined;
    shippingZipcode: string | undefined;
    shippingCountry: string | undefined;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
    partnerId: number;
    providerId: number;
    uuid: string | undefined;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.title = _data['title'];
            this.officeAddress = _data['officeAddress'];
            this.officeAddress2 = _data['officeAddress2'];
            this.officeCity = _data['officeCity'];
            this.officeState = _data['officeState'];
            this.officeZipcode = _data['officeZipcode'];
            this.officeCountry = _data['officeCountry'];
            this.shippingAddress = _data['shippingAddress'];
            this.shippingAddress2 = _data['shippingAddress2'];
            this.shippingCity = _data['shippingCity'];
            this.shippingState = _data['shippingState'];
            this.shippingZipcode = _data['shippingZipcode'];
            this.shippingCountry = _data['shippingCountry'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.phoneNumber = _data['phoneNumber'];
            this.password = _data['password'];
            this.isActive = _data['isActive'];
            this.shouldChangePasswordOnNextLogin = _data['shouldChangePasswordOnNextLogin'];
            this.isTwoFactorEnabled = _data['isTwoFactorEnabled'];
            this.isLockoutEnabled = _data['isLockoutEnabled'];
            this.partnerId = _data['partnerId'];
            this.providerId = _data['providerId'];
            this.uuid = _data['uuid'];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['title'] = this.title;
        data['officeAddress'] = this.officeAddress;
        data['officeAddress2'] = this.officeAddress2;
        data['officeCity'] = this.officeCity;
        data['officeState'] = this.officeState;
        data['officeZipcode'] = this.officeZipcode;
        data['officeCountry'] = this.officeCountry;
        data['shippingAddress'] = this.shippingAddress;
        data['shippingAddress2'] = this.shippingAddress2;
        data['shippingCity'] = this.shippingCity;
        data['shippingState'] = this.shippingState;
        data['shippingZipcode'] = this.shippingZipcode;
        data['shippingCountry'] = this.shippingCountry;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['phoneNumber'] = this.phoneNumber;
        data['password'] = this.password;
        data['isActive'] = this.isActive;
        data['shouldChangePasswordOnNextLogin'] = this.shouldChangePasswordOnNextLogin;
        data['isTwoFactorEnabled'] = this.isTwoFactorEnabled;
        data['isLockoutEnabled'] = this.isLockoutEnabled;
        data['partnerId'] = this.partnerId;
        data['providerId'] = this.providerId;
        data['uuid'] = this.uuid;
        return data;
    }

    clone(): UserEditDto {
        const json = this.toJSON();
        let result = new UserEditDto();
        result.init(json);
        return result;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    title: string | undefined;
    officeAddress: string | undefined;
    officeAddress2: string | undefined;
    officeCity: string | undefined;
    officeState: string | undefined;
    officeZipcode: string | undefined;
    officeCountry: string | undefined;
    shippingAddress: string | undefined;
    shippingAddress2: string | undefined;
    shippingCity: string | undefined;
    shippingState: string | undefined;
    shippingZipcode: string | undefined;
    shippingCountry: string | undefined;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
    partnerId: number;
    providerId: number;
    uuid: string | undefined;
}

export class UserListDtoPagedResultDto implements IUserListDtoPagedResultDto {
    totalCount: number;
    items: UserListDto[] | undefined;

    constructor(data?: IUserListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): UserListDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserListDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserListDtoPagedResultDto {
    totalCount: number;
    items: UserListDto[] | undefined;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
            this.userNameOrEmail = _data['userNameOrEmail'];
            this.clientIpAddress = _data['clientIpAddress'];
            this.clientName = _data['clientName'];
            this.browserInfo = _data['browserInfo'];
            this.result = _data['result'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        data['userNameOrEmail'] = this.userNameOrEmail;
        data['clientIpAddress'] = this.clientIpAddress;
        data['clientName'] = this.clientName;
        data['browserInfo'] = this.browserInfo;
        data['result'] = this.result;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserLoginAttemptDto {
        const json = this.toJSON();
        let result = new UserLoginAttemptDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment;
}

export class UserLoginAttemptDtoListResultDto implements IUserLoginAttemptDtoListResultDto {
    items: UserLoginAttemptDto[] | undefined;

    constructor(data?: IUserLoginAttemptDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserLoginAttemptDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): UserLoginAttemptDtoListResultDto {
        const json = this.toJSON();
        let result = new UserLoginAttemptDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginAttemptDtoListResultDto {
    items: UserLoginAttemptDto[] | undefined;
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    companyUuid: string | undefined;
    profilePictureId: string | undefined;
    partnerId: number | undefined;
    providerId: number | undefined;
    details: RollDetails[] | undefined;
    partnerName: string | undefined;
    isImpersonator: boolean;
    userExperience: string | undefined;
    isInvestOwner: boolean;
    uuid: string | undefined;
    marketplaceRoles: string[] | undefined;
    token: string | undefined;
    id: number;
}

export class UserRoleDto implements IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
    roleType: RoleType;
    description: string | undefined;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data['roleId'];
            this.roleName = _data['roleName'];
            this.roleDisplayName = _data['roleDisplayName'];
            this.isAssigned = _data['isAssigned'];
            this.roleType = _data['roleType'];
            this.description = _data['description'];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['roleId'] = this.roleId;
        data['roleName'] = this.roleName;
        data['roleDisplayName'] = this.roleDisplayName;
        data['isAssigned'] = this.isAssigned;
        data['roleType'] = this.roleType;
        data['description'] = this.description;
        return data;
    }

    clone(): UserRoleDto {
        const json = this.toJSON();
        let result = new UserRoleDto();
        result.init(json);
        return result;
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
    roleType: RoleType;
    description: string | undefined;
}
